import apiClient from './apiClient';

/**
 * Service for Maintenance scheduling and history.
 */
const maintenanceService = {
    async getSchedule() {
        return await apiClient.get('/maintenance/schedule');
    },

    async getHistory() {
        return await apiClient.get('/maintenance/history');
    },

    async getMaintenanceStats() {
        return await apiClient.get('/stats/maintenance');
    },

    // Upcoming service projections computed from real engine hours vs. the
    // A–H service-checklist intervals.
    async getUpcomingService(params = {}) {
        const qs = new URLSearchParams(params).toString();
        return await apiClient.get(`/maintenance/upcoming-service${qs ? `?${qs}` : ''}`);
    },

    // Preventive-maintenance schedule (imported MSC sheet) with live
    // remaining-days + DUE/OVERDUE/SCHEDULED status.
    async getPMSchedule() {
        return await apiClient.get('/maintenance/pm-schedule');
    },

    // Open MACHINE-category alarms (warnings) raised by the health checker.
    async getMachineWarnings() {
        return await apiClient.get('/alarms?category=MACHINE&status=OPEN');
    },

    // All open alarms (warnings + errors) across the site.
    async getOpenAlarms() {
        return await apiClient.get('/alarms?status=OPEN');
    },

    // Service-focused machine overview: last service + ticket history (with
    // action logs), next-service checklist to-do, and DTC fault codes.
    async getMachineServiceOverview(equipmentId) {
        return await apiClient.get(`/maintenance/machine/${encodeURIComponent(equipmentId)}/overview`);
    }
};

export default maintenanceService;
